import React, { ReactElement } from 'react';
import useSupplementedMultiTaskResponseAssignment from 'react-scale/hooks/useSupplementedMultiTaskResponseAssignment';
import { AssignmentJson } from '@scale/shared/assignmentJson/types/AssignmentJson';

interface SupplementedMultiTaskResponseAssignmentWrapperProps {
  assignment?: AssignmentJson;
  /**
   * This render should take an updated version of the TaskProps for the component
   */
  render: (assignment?: AssignmentJson) => ReactElement;
}

/**
 * A wrapper for TaskComponent to allow for hooks to be used on MultiTaskResponse.tsx
 */
export const SupplementedMultiTaskResponseAssignmentWrapper: React.FC<
  SupplementedMultiTaskResponseAssignmentWrapperProps
> = props => {
  const { assignment, render } = props;

  const supplementedMultiTaskResponseAssignmentJson =
    useSupplementedMultiTaskResponseAssignment(assignment);

  return render(supplementedMultiTaskResponseAssignmentJson);
};
